export class GradientMode {
}
GradientMode.Blend = 0;
GradientMode.Fixed = 1;
